import { IconCoins } from '@/components/custom';
import { getUserCoinCount } from '@/lib/utils';
import { TableCell } from '@/components/ui';
import { IHasUser } from '.';

export const DataTableBodyCellCoins = ({ user }: IHasUser) => (
  <TableCell className='text-right py-1 pe-0 w-0'>
    <div className='flex items-center justify-end space-x-2'>
      <span className='font-semibold'>
        {getUserCoinCount(user.coins ?? 0, user.diamondWallet?.coins).toLocaleString('fr-FR')}
      </span>
      <IconCoins />
    </div>
  </TableCell>
);

export default DataTableBodyCellCoins;
